import { render, staticRenderFns } from "./SignatureSettings.vue?vue&type=template&id=1c55c63e&scoped=true&"
import script from "./SignatureSettings.vue?vue&type=script&lang=js&"
export * from "./SignatureSettings.vue?vue&type=script&lang=js&"
import style0 from "./SignatureSettings.vue?vue&type=style&index=0&id=1c55c63e&lang=scss&scoped=true&"
import style1 from "./SignatureSettings.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c55c63e",
  null
  
)

export default component.exports